import { useCallback } from "react";
import { Button, Spinner } from "@heroui/react";
import { useRemoveFromBlacklist } from "./use-blacklist";

export type RemoveBlacklistButtonProps = {
  uid: string;
  isDisabled?: boolean;
  onRemoved?: () => void;
  confirmMessage?: string;
  children?: React.ReactNode;
};

/** 把用户移出我的黑名单。成功 / 失败 toast 与列表刷新由 mutation 统一处理。 */
export function RemoveBlacklistButton({
  uid,
  isDisabled = false,
  onRemoved,
  confirmMessage = "确定要将该用户移出黑名单吗？",
  children = "移除",
}: RemoveBlacklistButtonProps) {
  const removeFromBlacklist = useRemoveFromBlacklist();
  const pending = removeFromBlacklist.isPending;

  const handleRemove = useCallback(() => {
    if (pending) return;
    if (confirmMessage && !window.confirm(confirmMessage)) return;
    removeFromBlacklist.mutate(uid, { onSuccess: () => onRemoved?.() });
  }, [pending, confirmMessage, uid, onRemoved, removeFromBlacklist]);

  return (
    <Button
      size="sm"
      variant="danger-soft"
      className="rounded-full"
      onPress={handleRemove}
      isDisabled={isDisabled || pending}
      isPending={pending}
    >
      {({ isPending }) => (
        <>
          {isPending && <Spinner size="sm" color="current" />}
          {children}
        </>
      )}
    </Button>
  );
}
